// extracted by mini-css-extract-plugin
export default {"list":"breadcrumbs_list__YxwUG","listItem":"breadcrumbs_listItem__arbyS"};